const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    isAdminMenu: state => state.app.isAdminMenu,
    cachedViews: state => state.app.cachedViews,
    routerId: state => state.app.routerId,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    haveOutEmp: state => state.user.haveOutEmp,
    hasTx: state => state.user.hasTx,
    levels: state => state.user.levels,
    phone: state => state.user.phone,
    messageNoReadNum: state => state.user.messageNoReadNum,
    id: state => state.user.id,
    eName: state => state.user.eName,
    latLng: state => state.user.latLng,
    province: state => state.user.province,
    city: state => state.user.city,
    tenantId: state => state.user.tenantId,
    mapAk: state => state.app.mapAk,
    addRouters: state => state.permission.addRouters,
    modules: state => state.permission.modules,
    permission_routers: state => state.permission.routers,
    availableMedias: state => state.dic.availableMedias,
    industryTree: state => state.dic.industryTree,
    businessTree: state => state.dic.businessTree,
    thirdIndustryTree: state => state.dic.allThirdIndustryTree,
    mediaTypeTree: state => state.dic.mediaTypeTree,
    regionTree: state => state.dic.regionTree,
    errorLogs: state => state.errorLog.logs
};
export default getters;
